<script lang="ts">
    import type * as t from "./types";

    import { goToNextStep } from "./quiz-controller.svelte";
    import store from "./quiz-store";
    import type { Sequence } from "./sequence";

    export let segments: Sequence<t.Segment>;

    let segmentsConfig: t.SegmentConfig[] = [];
    for (const node of segments.iterate()) {
        const segment = node.value;
        const config = $store.config.segments[segment.id];
        if (config == null) {
            continue;
        }
        segmentsConfig.push(config);
    }

    function handleClickStart() {
        goToNextStep();
    }
</script>

<div>Segments Overview</div>

<div>
    {#each segmentsConfig as config}
        <div>Title: {config.title}</div>
        <div>Prize: {config.prize.discount_value}%</div>
    {/each}
</div>

<button on:click={handleClickStart}>Start</button>
